/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_Frames_SuccessInputs */



/**
* | output |
* | --- |
* | "Inserting blank frames finished successfully" |
*
* @param {Inserting_Blank_Frames_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames_success = /** @type {((inputs?: Inserting_Blank_Frames_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_Frames_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insertion d’images vides terminée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Einfügen der leeren Rahmen wurde erfolgreich abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserimento di cornici vuote completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставка пустых рамок успешно завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La inserción de marcos en blanco finalizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空白框插入完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白フレームの挿入が正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली फ्रेम डालने की प्रक्रिया सफलतापूर्वक पूरी हो गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A inserção das molduras em branco foi concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Inserting blank frames finished successfully")
});